import subscriptionStatuses from '@/util/subscriptionStatuses'

export default {
  subscriptionStatusOptions () {
    return Object.keys(subscriptionStatuses).map(key => {
      return {
        label: subscriptionStatuses[key],
        value: parseInt(key),
      }
    })
  },
}
